export default __webpack_public_path__ + "static/media/pc-or-vr-technologies.66be81e8.svg";